import React, { type ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadVigboAlbumsListRequest } from 'reactApp/modules/vigbo/vigbo.module';
import { getVigboAlbums, getVigboLoadingState } from 'reactApp/modules/vigbo/vigbo.selectors';
import { SelectAlbumPopup } from 'reactApp/ui/SelectAlbumPopup/SelectAlbumPopup';
import type { SelectAlbumCallbackProps, SelectAlbumTextProps } from 'reactApp/ui/SelectAlbumPopup/SelectAlbumPopup.types';

export interface SelectVigboAlbumPopupProps extends SelectAlbumCallbackProps {}

const texts: SelectAlbumTextProps = {
    title: 'Выберите галерею Vigbo',
    createAlbumBttnText: 'Создать галерею Vigbo',
    successBttnText: 'Добавить в галерею',
    emptyTitle: 'У вас пока не галерей',
    emptyText: 'Создайте свою первый галерею Vigbo и добавляйте в нее фото',
    emptyBttnText: 'Создать галерею',
};

export function SelectVigboAlbumPopup(props: SelectVigboAlbumPopupProps): ReactElement {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadVigboAlbumsListRequest());
    }, []);

    const albums = useSelector(getVigboAlbums);
    const { isLoading, isLoaded } = useSelector(getVigboLoadingState);

    return <SelectAlbumPopup albums={albums} error={!isLoading && !isLoaded} isLoading={isLoading && !isLoaded} {...props} {...texts} />;
}
